import 'normalize.css'
import InventoryContainer from '../Inamove/Containers/InventoryContainer/InventoryContainer'
import InventoryCombinationsController from '../Inamove/Controllers/InventoryCombinationsController'
import LevelController from '../Inamove/Controllers/LevelController'
import LevelListContainer, { GameStartFn } from '../Inamove/Containers/LevelListContainer/LevelListContainer'
import './index.scss'
import GameContainer from '../Inamove/Containers/GameContainer/GameContainer'
import levelList from './levelList'
import level1 from './levels/level1'
import level2 from './levels/level2'
import level3 from './levels/level3'
import level4 from './levels/level4'
import level5 from './levels/level5'
import level6 from './levels/level6'
import level7 from './levels/level7'
import level8 from './levels/level8'
import level9 from './levels/level9'
import level10 from './levels/level10'
import level11 from './levels/level11'
import level12 from './levels/level12'
import level13 from './levels/level13'
import level14 from './levels/level14'
import level15 from './levels/level15'
import level16 from './levels/level16'
import intro from './levels/intro'

const levels = [
    intro,
    level1,
    level2,
    level3,
    level4,
    level5,
    level6,
    level7,
    level8,
    level9,
    level10,
    level11,
    level12,
    level13,
    level14,
    level15,
    level16,
]

const startGame: GameStartFn = async (kapitelIndex: number) => {
    LevelController.hideMenu()
    await InventoryContainer.load()
    await InventoryCombinationsController.load()

    let currentKapitel = kapitelIndex

    while (currentKapitel < levelList.length) {
        await levels[currentKapitel]()
        LevelController.destroyLevel(levelList[currentKapitel].id)

        if (currentKapitel + 1 < levelList.length) {
            LevelListContainer.unlockLevel(levelList[currentKapitel + 1].id)
        }

        currentKapitel++
    }

    LevelController.showMenu()
}

const button = document.querySelector('#new-game') as HTMLButtonElement
button.onclick = async () => {
    await startGame(0)
}

LevelListContainer.init(levelList, startGame)

GameContainer.show()
